import React from 'react'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import styles from './shortUrlComponent.scss'
import PropTypes from 'prop-types'
export function ShortUrl (props: Props) {
  const { t } = props
  return (
    <div>
      <h1>{t('url:title')}</h1>
      <p>{t('url:save')}</p>
      {props.shortUrl ? (
        <pre>{props.shortUrl}</pre>
      ) : (
        <p>{t('url:couldNot')}</p>
      )}
    </div>
  )
}
ShortUrl.propTypes = {
  t: PropTypes.func.isRequired,
  shortUrl: PropTypes.string
}

export default compose(pure, translate())(ShortUrl)



// WEBPACK FOOTER //
// ./src/components/shortUrl/shortUrlComponent.js